import { DispenserTimelineItem } from '@/features/dispensers/services/schemas.ts';

export function isEventGroup(timelineItem: DispenserTimelineItem): boolean {
  return timelineItem.eventsCount > 1;
}
